/* Product page extras.

   Everything here is grafted onto Horizon's own product section rather than
   forked into a custom one, so the theme can still be updated: a heart beside
   the title, and a square magnifier that follows the pointer over the main
   image.

   THE DATASHEET BUTTON MOVED. It used to live here, under the buy buttons.
   There are no buy buttons any more, so it is now one half of the pair that
   gs-nocart.js puts on every product and every card — Request Datasheet and
   Buy now. Leaving a second one here produced two datasheet buttons side by
   side.

   The product's details arrive in the #gs-product-state JSON block, printed by
   snippets/gs-site-chrome.liquid on product templates only. */

(function () {
  'use strict';

  var node = document.getElementById('gs-product-state');
  if (!node) return;

  var P;
  try { P = JSON.parse(node.textContent); } catch (err) { return; }
  if (!P || !P.handle) return;

  /* ------------------------------------------------- heart by the title */

  var title = document.querySelector('.product-information h1, .product__title h1, main h1');
  if (title && !title.parentElement.querySelector('[data-gs-wish]')) {
    var row = document.createElement('div');
    row.className = 'gs-title-row';

    var heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'gs-heart';
    heart.dataset.gsWish = P.handle;
    heart.setAttribute('aria-label', 'Save ' + P.title + ' to your wishlist');

    title.parentElement.insertBefore(row, title);
    row.appendChild(title);
    row.appendChild(heart);

    if (window.GSWishlist && window.GSWishlist.sync) window.GSWishlist.sync();
  }

  /* ----------------------------------------------------------- the lens */

  var ZOOM = 2.6;
  var lens = null;

  function big(src) {
    /* Ask Shopify for a large rendition of whatever is on screen. */
    return src.replace(/(_\d+x\d*)?(\.[a-z]+)(\?|$)/i, '_1600x$2$3');
  }

  function attach(img) {
    var host = img.closest('.gs-lens-host') || img.parentElement;
    if (!host || host.dataset.gsLens === '1') return;
    host.dataset.gsLens = '1';
    host.classList.add('gs-lens-host');

    host.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;

      if (!lens) {
        lens = document.createElement('div');
        lens.className = 'gs-lens';
        document.body.appendChild(lens);
      }

      if (lens.parentElement !== host) host.appendChild(lens);
      lens.style.backgroundImage = 'url("' + big(img.currentSrc || img.src) + '")';
      lens.classList.add('is-on');
    });

    host.addEventListener('pointerleave', function () {
      if (lens) lens.classList.remove('is-on');
    });

    host.addEventListener('pointermove', function (event) {
      if (!lens || event.pointerType !== 'mouse') return;

      var r = img.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      var x = event.clientX - r.left;
      var y = event.clientY - r.top;

      if (x < 0 || y < 0 || x > r.width || y > r.height) {
        lens.classList.remove('is-on');
        return;
      }

      lens.classList.add('is-on');

      var size = lens.offsetWidth || 190;
      lens.style.left = Math.round(event.clientX - hr.left - size / 2) + 'px';
      lens.style.top = Math.round(event.clientY - hr.top - size / 2) + 'px';

      lens.style.backgroundSize = Math.round(r.width * ZOOM) + 'px ' + Math.round(r.height * ZOOM) + 'px';
      lens.style.backgroundPosition =
        Math.round(-(x * ZOOM - size / 2)) + 'px ' + Math.round(-(y * ZOOM - size / 2)) + 'px';
    });
  }

  function scan() {
    var imgs = document.querySelectorAll(
      '.product-media-gallery img, .product-media-container img, slideshow-slide img, .product__media img'
    );
    Array.prototype.forEach.call(imgs, attach);
  }

  scan();
  window.setTimeout(scan, 1200);
})();
